import { Helmet } from "react-helmet-async";
import profileImage from "../../Images/blankprofile.jpg";

const SeoProfileMetadata = ({ data, canonicalUrl }) => {

    const location = [data?.location, data?.emirate, data?.countryName]
        .filter(Boolean)
        .join(', ');

    let description = `${data?.personName}, ${data?.designation}`;
    if (data?.companyName) {
        description += ` of ${data.companyName}`;
    }
    if (location) {
        description += ` in ${location}`;
    }
    if (data?.serviceName) {
        description += ` offering ${data?.serviceName?.map(s => s).join(', ')}`;
    }
    let metaTitle = `${data?.personName} | ${data?.designation}`;
    if (data?.companyName) {
        metaTitle += ` | ${data.companyName}`;
    }
    metaTitle += ` | NeooCard`;
    return (
        <Helmet>
            <title>{metaTitle}</title>
            <meta name="description" content={description} data-rh="true" />
            {/* <link rel="canonical" href={data?.userLink} /> */}
            <meta property="og:title" content={metaTitle} data-rh="true" />
            <meta property="og:description" content={description} data-rh="true" />
            <meta property="og:image" content={data?.neooCardImageUrl || profileImage} data-rh="true" />
            <meta property="og:url" content={canonicalUrl} data-rh="true" />
            <meta property="og:type" content="profile" data-rh="true" />
            <meta property="og:site_name" content="Neoo Search" data-rh="true" />

            <meta name="twitter:card" content="summary_large_image" data-rh="true" />
            <meta name="twitter:title" content={metaTitle} data-rh="true" />
            <meta name="twitter:description" content={description} data-rh="true" />
            <meta name="twitter:image" content={data?.neooCardImageUrl || profileImage} data-rh="true" />
            <meta name="twitter:image:alt" content={`Photo of ${data?.personName}`} data-rh="true" />

            <link rel="canonical" href={canonicalUrl} />
        </Helmet>
    );
}
export default SeoProfileMetadata;
